<div class="card" style="top: 5px; min-height: 85vh">

    <p-table #dt [value]="results" [rows]="10" [paginator]="true" [autoLayout]="true" styleClass="p-datatable-striped"
             [globalFilterFields]="['name','comment','CODE','MEMBERS']"
        [(selection)]="selectedResults" [rowHover]="true" dataKey="ID"
        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
             [showCurrentPageReport]="true">
        <ng-template pTemplate="caption">
            <div class="p-d-flex p-ai-center p-jc-between" style="margin:0 20px">
                <h2 class="p-m-0">{{tableName}}</h2>
                <div class="p-jc-end">
                    <div class="p-input-icon-left p-mr-2">
                        <i class="pi pi-search"></i>
                        <input pInputText type="text" (input)="dt.filterGlobal($any($event.target).value, 'contains')"
                               placeholder="Search..." />
                    </div>
                    <button pButton pRipple pTooltip="Add a new record"
                            tooltipPosition="bottom" icon="pi pi-plus"
                            class="p-button-rounded p-button-success p-mr-2" (click)="openNew()"></button>
                    <button *ngIf="selectedResults && selectedResults.length" pButton pRipple
                            pTooltip="Delete selected records"  tooltipPosition="bottom" icon="pi pi-trash"
                            class="p-button-rounded p-button-danger  p-mr-2" (click)="deleteSelectedResults()"></button>
                    <button pButton pRipple pTooltip="Close"
                            tooltipPosition="bottom" icon="pi pi-times"
                            class="p-button-rounded p-button-secondary p-button-outlined" (click)="close()"></button>
                </div>
            </div>
        </ng-template>
        <ng-template pTemplate="header">
            <tr>
                <th style="text-align: center">ACTIONS</th>
                <th style="width: 2rem;">
                    <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
                </th>
                <ng-container *ngFor="let col of cols">
                    <th *ngIf="col.field != 'ID'" pSortableColumn="{{col.field}}" >
                        {{col.header}}<p-sortIcon field="{{col.field}}"></p-sortIcon>
                    </th>
                </ng-container>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-result>
            <tr *ngIf="result['ID'] != null">
                <td>
                    <div style="text-align:center">
                        <button pButton pRipple pTooltip="Edit the record"
                                tooltipPosition="bottom" icon="pi pi-pencil" class="p-button-rounded p-button-success p-mr-2"
                                (click)="editResult(result)"></button>
                        <button pButton pRipple pTooltip="Delete the record"
                                tooltipPosition="bottom" icon="pi pi-trash" class="p-button-rounded p-button-warning p-mr-2"
                                (click)="deleteResult(result)"></button>
                    </div>
                </td>
                <td>
                    <p-tableCheckbox [value]="result"></p-tableCheckbox>
                </td>
                <ng-container *ngFor="let col of cols">
                    <td *ngIf="col.field != 'ID'">
                        {{(result[col.field] == null || result[col.field] == undefined) ? '':result[col.field]}}
                    </td>
                </ng-container>
            </tr>
        </ng-template>
    </p-table>
</div>

<!-- Dialog for editing a row  -->
<p-dialog [(visible)]="rowEditor" [style]="{width: '50%'}" header="Record Editing"
          [modal]="true" styleClass="p-fluid">
    <ng-template pTemplate="content">
        <div class="p-field">
            <label for="CODE">Group Code (ends with a "*")</label>
            <input type="text" pInputText id="CODE" [(ngModel)]="result.CODE" required autofocus />
        </div>
        <div class="p-field">
            <label for="MEMBERS">Airport Members</label>
            <p-autoComplete id="MEMBERS" appendTo="body"
                    field="code" (onSelect)="selectAirport($event)"
                    (onFocus)="$event.target.select()" #airportInput (onKeyUp)="airportKeyUp($event)"
                    [multiple]="true" [(ngModel)]="selectedObjects" [inputStyle]="{width:'295px'}"
                    [suggestions]="filteredAirports" (completeMethod)="filterAirport($event)"
                    [dropdown]="true" [forceSelection]="true" [autoHighlight]="true"
                    placeholder="Airport" class="p-mr-2">
                <ng-template appendTo="body" let-obj pTemplate="item">
                  <div>{{obj.display}}</div>
                </ng-template>
            </p-autoComplete>
            <button pButton *ngIf="selectedObjects.length>0" icon="pi pi-times"  class="p-button-text p-button-plain"
                    (click)="clearAirports()" style="float:right;right:35px;top:-31px;z-index:999;padding:5px;"></button>
        </div>

        <div class="p-field">
            <label for="Description">Description</label>
            <textarea rows="3" pInputText id='Description'
                      [(ngModel)]="result.DESCRIPTION" required autofocus>
                {{result.DESCRIPTION}}
            </textarea>
        </div>
    </ng-template>
    
    <ng-template pTemplate="footer">
        <button pButton pRipple label="Cancel" icon="pi pi-times" class="p-button-text" (click)="hideDialog()"></button>
        <button pButton pRipple label="Save" icon="pi pi-check" class="p-button-text" (click)="saveResult()"></button>
    </ng-template>
</p-dialog>

<!-- Message -->
<p-toast position="bottom-center"></p-toast>
<p-confirmDialog [style]="{width: '450px'}"></p-confirmDialog>

<!-- Loading Spinner -->
<img class="progress-spinner rotate" *ngIf="loading" src="assets/loading.png" alt="loading...">
